export default function Services() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Dermal Fillers',
      description: 'Restore volume and smooth fine lines with our premium hyaluronic acid fillers for natural-looking results.',
      gradient: 'from-esthe-light-pink to-esthe-rose'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Laser Treatments',
      description: 'Advanced laser technology for skin rejuvenation, hair removal, and pigmentation correction.',
      gradient: 'from-esthe-pale-taupe to-esthe-light-bronze'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Botox & Dysport',
      description: 'Reduce wrinkles and prevent new lines with expertly administered neuromodulator treatments.',
      gradient: 'from-esthe-rose to-esthe-light-coral'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'Chemical Peels',
      description: 'Reveal brighter, smoother skin with customized chemical peel treatments for all skin types.',
      gradient: 'from-esthe-light-bronze to-esthe-mocha'
    },
    {
      icon: 'ri-drop-line',
      title: 'Microneedling',
      description: 'Stimulate collagen production and improve skin texture with advanced microneedling techniques.',
      gradient: 'from-esthe-blush-pink to-esthe-deep-carmine'
    },
    {
      icon: 'ri-sun-line',
      title: 'Skin Rejuvenation',
      description: 'Comprehensive treatments to restore your skin\'s youthful glow and radiance.',
      gradient: 'from-esthe-light-pink to-esthe-blush-pink'
    },
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white via-esthe-floral-white to-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <p className="text-esthe-light-bronze text-sm tracking-widest uppercase mb-4 font-medium">
            / OUR SERVICES
          </p>
          <h2 className="text-5xl font-serif mb-6 text-esthe-cafe-noir">
            Signature Treatments
          </h2>
          <p className="text-lg text-esthe-mocha max-w-2xl mx-auto">
            Discover our comprehensive range of aesthetic treatments designed to enhance your natural beauty
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-esthe-pale-taupe/20 hover:-translate-y-2"
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${service.gradient} mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-serif mb-4 text-esthe-cafe-noir group-hover:text-esthe-light-bronze transition-colors">
                {service.title}
              </h3>
              <p className="text-esthe-mocha leading-relaxed mb-6">
                {service.description}
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 text-esthe-light-bronze font-medium hover:gap-4 transition-all cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
